<template>
  <ImbpRegisterInterestModal
    v-if="showAvailabilityForm"
    :model-value="showAvailabilityForm"
    @update:model-value="markSeen"
    @success="markSeen"
  />
  <SoDialog
    v-else
    v-model="value"
    card-title="This customer has RTS meters"
    :max-width="500"
  >
    <span class="font-weight-bold">Tell the customer:</span> You have Radio
    Teleswitch (RTS) meters fitted at your property. Unless you get them
    upgraded to smart meters before the end of June 2025, they will stop being
    able to switch your heating on and off at certain times, and you will be
    stuck with heating permanently on or off.
    <div class="d-flex justify-end gap-1 mt-8">
      <SoButton
        title="Book Smart Meter Install"
        :loading="current.imbpAvailability.isLoading"
        data-testid="rts-meter-button"
        type="success"
        large
        @click="handleBookSmartMeterInstall"
      />
      <SoButton title="close" large @click="value = false" />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { RouteNames } from "@/types/router"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import ImbpRegisterInterestModal from "@/views/customer/imbp/components/ImbpRegisterInterestModal.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"

  export default defineComponent({
    components: {
      SoDialog,
      SoButton,
      ImbpRegisterInterestModal,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],

    data() {
      return {
        current: useCurrentAccountStore(),
        showAvailabilityForm: false,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value) {
          this.$emit("update:modelValue", value)
          this.current.seenRtsMeterModal = true
        },
      },
    },

    methods: {
      markSeen() {
        this.showAvailabilityForm = false
        this.$emit("update:modelValue", false)
        this.current.seenRtsMeterModal = true
      },
      async handleBookSmartMeterInstall() {
        try {
          if (this.current.imbpAvailability.data?.hasAvailableSlots) {
            this.$router.push({
              name: RouteNames.CustomerImbp,
            })
            this.value = false
          } else {
            this.showAvailabilityForm = true
          }
        } catch (err) {
          this.showAvailabilityForm = true
        }
      },
    },
  })
</script>
